import { USE_CASE_IDS } from '../types/filters';
import { ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
export const USE_CASES_BY_TAB = {
  [ANALYTICS_SUITE_TAB_IDS.MARKETING]: [{
    id: USE_CASE_IDS.LEAD_GENERATION,
    titleKey: 'smartLibrary.analyticsSuite.useCases.marketing.leadGeneration',
    originalIndex: 0
  }, {
    id: USE_CASE_IDS.AUTOMATE_MARKETING,
    titleKey: 'smartLibrary.analyticsSuite.useCases.marketing.automateMarketing',
    originalIndex: 1
  }],
  [ANALYTICS_SUITE_TAB_IDS.SALES]: [{
    id: USE_CASE_IDS.BUILD_PIPELINE,
    titleKey: 'smartLibrary.analyticsSuite.useCases.sales.buildPipeline',
    originalIndex: 2
  }, {
    id: USE_CASE_IDS.CLOSE_DEALS,
    titleKey: 'smartLibrary.analyticsSuite.useCases.sales.closeDeals',
    originalIndex: 3
  }],
  [ANALYTICS_SUITE_TAB_IDS.COMMERCE]: [{
    id: USE_CASE_IDS.COLLECT_PAYMENTS_AND_SUBSCRIPTIONS,
    titleKey: 'smartLibrary.analyticsSuite.useCases.commerce.collectPaymentsAndSubscriptions',
    originalIndex: 4
  }, {
    id: USE_CASE_IDS.AUTOMATE_BILLING_AND_INVOICING,
    titleKey: 'smartLibrary.analyticsSuite.useCases.commerce.automateBillingAndInvoicing',
    originalIndex: 5
  }],
  [ANALYTICS_SUITE_TAB_IDS.SERVICE]: [{
    id: USE_CASE_IDS.SCALE_SUPPORT,
    titleKey: 'smartLibrary.analyticsSuite.useCases.service.scaleSupport',
    originalIndex: 6
  }, {
    id: USE_CASE_IDS.DRIVE_RETENTION,
    titleKey: 'smartLibrary.analyticsSuite.useCases.service.driveRetention',
    originalIndex: 7
  }]
};
export const ALL_USE_CASES = [...USE_CASES_BY_TAB[ANALYTICS_SUITE_TAB_IDS.MARKETING], ...USE_CASES_BY_TAB[ANALYTICS_SUITE_TAB_IDS.SALES], ...USE_CASES_BY_TAB[ANALYTICS_SUITE_TAB_IDS.COMMERCE], ...USE_CASES_BY_TAB[ANALYTICS_SUITE_TAB_IDS.SERVICE]];